"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PetBird = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PetBird = function PetBird(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.796 25.988a.748.748 0 00-1.002-.329l-.955.48v-.997c.267-.385.494-.918.68-1.464a46.578 46.578 0 01-2.74 2.04 8.016 8.016 0 001.078.128v.787l-.13.064h-2.404c-.351.231-.712.465-1.086.703l-.105.288h3.025a.694.694 0 00.041.107.746.746 0 001.002.33l.868-.437h4.747v-.99h-3.042a.741.741 0 00.023-.71zm3.775-14.013c-.122-.515-.506-.88-.506-.88-.593.485-1.427.356-1.427.356s-.494.945-.633 1.722c-.14.776.505 1.11.505 4.05.015 1.229-.391 2.623-1.707 3.97-1.836 1.882-4.86 3.96-7.387 5.551l-2.69 7.429L12 35c.233-2.23.634-4.465.992-6.201-.618.354-.992.557-.992.557 1.146-7.1 2.45-10.936 3.534-13.129l.003-.008c1.119-2.312 1.923-3.093 2.895-4.577.974-1.484 2.92-4.513 5.291-4.635 2.373-.12 3.102 1.318 3.102 1.318 2.099 1.954.746 3.65.746 3.65z",
    fill: "#97BA1E"
  }));
};

exports.PetBird = PetBird;
var _default = PetBird;
exports.default = _default;